/**
 * Load failures on the Eval pages, kept as data and turned into text at render, so
 * a locale change re-labels them without refetching.
 */
import type { TFunction } from 'i18next';

export type EvalErrorKey =
  | 'usage.loadFailed'
  | 'insights.loadFailed'
  | 'insights.conversationFailed'
  | 'insights.casesFailed'
  | 'tasks.loadFailed'
  | 'continuous.evaluationsFailed';

/** An Error's own message, or a fallback key for anything else that was thrown. */
export type LoadError = { message: string } | { key: EvalErrorKey };

/** An Error with no message yields null, so the page shows no error, as before. */
export function toLoadError(err: unknown, key: EvalErrorKey): LoadError | null {
  if (err instanceof Error) return err.message ? { message: err.message } : null;
  return { key };
}

export function loadErrorText(error: LoadError, t: TFunction<'eval'>): string {
  return 'message' in error ? error.message : t(error.key);
}
